import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const POPULATION_LAYER_ID = 'populationLayer';

const layerConfig = {
  title: 'Population',
};

function PopulationLayer() {
  const dispatch = useDispatch();
  const { populationLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, populationLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });

  if (populationLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: POPULATION_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: populationLayer.visible,
      opacity: populationLayer.opacity,

      getFillColor: colorBins({
        attr: 'Total_Population',
        domain: [1000, 2000, 2500, 3000, 4000],
        colors: [
          [251, 230, 197],
          [245, 186, 152],
          [220, 113, 118],
          [200, 88, 108],
          [156, 63, 93],
          [112, 40, 74],
        ],
      }),
      pointRadiusMinPixels: 3.5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: POPULATION_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: [
                'Block_Group_Identifier',
                'Total_Population',
                'Children_Percentage',
                'Senior_Percentage',
              ],
            }),
          };
        }
      },
    });
  }
}

export default PopulationLayer;
